// @flow
export { default as border } from './border'
export * as breakpoint from './breakpoint'
export * as colors from './constants/color'
export { default as ellipsis } from './ellipsis'
export { default as margin } from './margin'
export { default as padding } from './padding'
export * as shadow from './boxShadow'
export { default as spacing } from './constants/spacing'
export * as transition from './transition'
export * as typography from './typography'
export * from './util'
export * as wordWrap from './wordWrap'
export { default as flexbox } from './props/flexbox'
export { default as size } from './props/size'
export { default as space } from './props/space'

export { fonts } from './styleConfig'
export type { SpaceProps } from './props/space'

// eslint-disable-next-line
export { default as base } from './base'



// WEBPACK FOOTER //
// ./src/style/index.js